import FirestickStep1 from '../assets/FirestickStep1.webp'
import FirestickStep2 from '../assets/FirestickStep2.webp'
import FirestickStep3 from '../assets/FirestickStep3.jpg'
import FirestickStep4 from '../assets/FirestickStep4.jpg'
import FirestickStep5 from '../assets/FirestickStep5.jpg'
import FirestickStep6 from '../assets/FirestickStep6.jpg'
import googlePlayHome from '../assets/googlePlayHome.png'
import googlePlayInstallApp from '../assets/googlePlayInstallApp.png'
import googlePlayOpenApp from '../assets/googlePlayOpenApp.png'
import googlePlaySearch from '../assets/googlePlaySearch.png'
import googlePlaySearchResults from '../assets/googlePlaySearchResults.png'

export enum COLORS {
  Error = '#ED4337',
  Success = '#4BB543',
  HiddenGemzRed = '#9C353E',
  HiddenGemzGold = '#9A7432',
  BasicTextGray = '#637587',
  LightGray = '#f6f6f6',
  DarkGreen = '#033723',
  LightGreen = '#16503A',
}

export const STATES: string[] = [
  'Tennessee',
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
]

export const BUSINESSTIMES = [
  { value: '12:00 AM', label: '12:00 AM' },
  { value: '12:30 AM', label: '12:30 AM' },
  { value: '01:00 AM', label: '1:00 AM' },
  { value: '1:30 AM', label: '1:30 AM' },
  { value: '2:00 AM', label: '2:00 AM' },
  { value: '2:30 AM', label: '2:30 AM' },
  { value: '3:00 AM', label: '3:00 AM' },
  { value: '3:30 AM', label: '3:30 AM' },
  { value: '4:00 AM', label: '4:00 AM' },
  { value: '4:30 AM', label: '4:30 AM' },
  { value: '5:00 AM', label: '5:00 AM' },
  { value: '5:30 AM', label: '5:30 AM' },
  { value: '6:00 AM', label: '6:00 AM' },
  { value: '6:30 AM', label: '6:30 AM' },
  { value: '7:00 AM', label: '7:00 AM' },
  { value: '7:30 AM', label: '7:30 AM' },
  { value: '8:00 AM', label: '8:00 AM' },
  { value: '8:30 AM', label: '8:30 AM' },
  { value: '9:00 AM', label: '9:00 AM' },
  { value: '9:30 AM', label: '9:30 AM' },
  { value: '10:00 AM', label: '10:00 AM' },
  { value: '10:30 AM', label: '10:30 AM' },
  { value: '11:00 AM', label: '11:00 AM' },
  { value: '11:30 AM', label: '11:30 AM' },
  { value: '12:00 PM', label: '12:00 PM' },
  { value: '12:30 PM', label: '12:30 PM' },
  { value: '1:00 PM', label: '1:00 PM' },
  { value: '1:30 PM', label: '1:30 PM' },
  { value: '2:00 PM', label: '2:00 PM' },
  { value: '2:30 PM', label: '2:30 PM' },
  { value: '3:00 PM', label: '3:00 PM' },
  { value: '3:30 PM', label: '3:30 PM' },
  { value: '4:00 PM', label: '4:00 PM' },
  { value: '4:30 PM', label: '4:30 PM' },
  { value: '5:00 PM', label: '5:00 PM' },
  { value: '5:30 PM', label: '5:30 PM' },
  { value: '6:00 PM', label: '6:00 PM' },
  { value: '6:30 PM', label: '6:30 PM' },
  { value: '7:00 PM', label: '7:00 PM' },
  { value: '7:30 PM', label: '7:30 PM' },
  { value: '8:00 PM', label: '8:00 PM' },
  { value: '8:30 PM', label: '8:30 PM' },
  { value: '9:00 PM', label: '9:00 PM' },
  { value: '9:30 PM', label: '9:30 PM' },
  { value: '10:00 PM', label: '10:00 PM' },
  { value: '10:30 PM', label: '10:30 PM' },
  { value: '11:00 PM', label: '11:00 PM' },
  { value: '11:30 PM', label: '11:30 PM' },
]

export const DAYSOFWEEK = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
]

export enum OnboardingSteps {
  OrganizationName,
  Category,
}

export enum HostOnboardingSteps {
  Instructions,
  LocationName,
  LocationDescription,
  Address,
  LocationPhotos,
  FootTraffic,
  SetBusinessHours,
  BankingInfo,
  DeviceSetupInstructions,
  DownloadTVAppInstructions,
  LinkDevice,
  DevicePhotos,
  DeviceName,
  DeviceSize,
  SetPricing,
  ApprovalType,
  AdvertiserRestrictions,
  Review,
}

export enum DeviceTypes {
  FireTV,
  SmartTV,
  Roku,
}

export enum ApprovalTypes {
  Auto = 'Auto',
  Manual = 'Manual',
}

export enum AdSelectionTypes {
  UploadAd = 'Upload Ad',
  SelectExistingAd = 'Select Existing Ad',
  PayForDesign = 'Request Design',
}

export enum OnboardingWizardPages {
  Onboarding = 'Onboarding',
  ManageLocation = 'Location',
  ManageDevice = 'Device',
}

export const ApprovalTypeOptions = [
  {
    value: ApprovalTypes.Auto,
    name: 'Automatically Approve Ads',
    description:
      'Ads will automatically begin running after a content verification to ensure they meet our guidelines.',
  },
  {
    value: ApprovalTypes.Manual,
    name: 'Manually Approve Ads',
    description:
      'Ads must be manually approved by you before being displayed on your device.',
  },
]

export const FireTVDownloadSteps = [
  {
    instructions:
      'Go to the Fire TV home screen by pressing the Home button on your remote',
    imageUrl: '',
  },
  {
    instructions:
      'Select "Find" by pressing the right directional button on your remote until the magnifying glass icon is highlighted.',
    imageUrl: FirestickStep1,
  },
  {
    instructions:
      'Press the down button on your remote to select the search bar',
    imageUrl: FirestickStep2,
  },
  {
    instructions:
      'Type "Hidden Gemz Display" using your remote, and navigate down to select the app\'s name once it appears',
    imageUrl: FirestickStep3,
  },
  {
    instructions:
      'Select the app icon. If not visible, scroll right or down to find it',
    imageUrl: FirestickStep4,
  },
  {
    instructions: 'Select Download to download the app',
    imageUrl: FirestickStep5,
  },
  {
    instructions:
      'Once the download is complete, press Open to start using the app',
    imageUrl: FirestickStep6,
  },
]

export const GooglePlayDownloadSteps = [
  {
    instructions:
      'Go to the home screen by pressing the Home button on your remote',
    imageUrl: '',
  },
  {
    instructions:
      'Locate and select the Google Play Store app from your Home screen or Apps menu.',
    imageUrl: googlePlayHome,
  },
  {
    instructions: 'In the Play Store, select the search button at the top',
    imageUrl: googlePlaySearch,
  },
  {
    instructions:
      'In the search bar, type "Hidden Gemz." Then, select the "Hidden Gemz Display" app from the results',
    imageUrl: googlePlaySearchResults,
  },
  {
    instructions:
      'Once you’ve selected the app, click on the "Install" button to download and install the app on your Smart TV.',
    imageUrl: googlePlayInstallApp,
  },
  {
    instructions:
      'After the installation is complete, you can either click "Open" directly from the Play Store or find the app in your Apps menu to start using it.',
    imageUrl: googlePlayOpenApp,
  },
]

export const AdDesignPrice = 50
export enum AdStatuses {
  AwaitingCheckout = 'AwaitingCheckout',
  PendingContentCheck = 'PendingContentCheck',
  PendingApproval = 'PendingApproval',
  PendingAdvertiserApproval = 'PendingAdvertiserApproval',
  PendingDesign = 'PendingDesign',
  ChangesRequested = 'ChangesRequested',
  Upcoming = 'Upcoming',
  Denied = 'Denied',
  Running = 'Running',
  Completed = 'Completed',
  PaymentDeclined = 'PaymentDeclined',
  Disabled = 'Disabled',
}

export function getAdStatusColor(status: string): string {
  switch (status) {
    case AdStatuses.Running: return 'green'
    case AdStatuses.PendingApproval:
    case AdStatuses.PendingContentCheck: return 'yellow'
    case AdStatuses.Denied: return 'red'
    case AdStatuses.Completed: return 'gray'
    case AdStatuses.Upcoming: return 'blue'
    case AdStatuses.Disabled: return 'orange'
    default: return 'gray'
  }
}

export function getAdStatusLabel(status: string): string {
  switch (status) {
    case AdStatuses.PendingContentCheck: return 'Pending Content Check'
    case AdStatuses.PendingApproval: return 'Pending Approval'
    case AdStatuses.Running: return 'Running'
    case AdStatuses.Upcoming: return 'Upcoming'
    case AdStatuses.Completed: return 'Completed'
    case AdStatuses.Denied: return 'Denied'
    case AdStatuses.Disabled: return 'Disabled'
    default: return status
  }
}

export const defaultImageUrl =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQgAAACUCAMAAABY+0dBAAAAPFBMVEXMzMx1dXWqqqpvb2/Y2NhmZmbPz8+4uLhsbGyCgoJycnLGxsaHh4d/f3/BwcG9vb2YmJifn5+wsLCSkpKrvAXxAAAC4ElEQVR4nO2c23arIBBAveSMiqCo//+vB41JvZA0Te3KEvZ+LqyyC+MMUJIEAAAAAAAAAAAAAAAAAAAAAAAA/gS5HIp8ejxvIklm/h2IyZJzqmh0qdIDUaVuPj2md6hteaSGkdzWnx7VG7TpofNhRKXtp0f1Bn0+/REPY+qt//Sofo5k48owbXEQrXHdldn5wuVVRHVJ5BCSS3VuEYf94oKIuT9EzP0hYu4vLhHy8OdjEuEsNM2jeiIiEVJo4+j8KqIRIaJz5ZJylaetr1E0IhJ9K02UKjytYhEh3VeJpqpm3ywSEdJWy1q1i1dEtiq39X7fIRIRSbecEKrax8tYRNh8KcLsw2UsIrqVCL2PlpGIkH4ZI/LB8xORiKj1Mkj00X413JQwXyvDerLsEEV4S0y3ONRtYdRxZJbS+lLocU6Mm9UqtT4PAYqQVqeZd1I0WWdtVkRSfUqjlVKDz8TTQYYmQpqpqPBlCt/0F5YIacw1c8rNDw+twhJx9zCeY756yi9TBRaUiIWHcSvKvrI8JOnteBsgJBHue7GsKNJcezfl1t24urQap0RAIpyHzUWBvPLk0ute6sH5CkvEZhPqpUBxKVwbFZYIFx98F0eUfXKmI920rx2UCGnS3OPBjc23U3ttUg/T5aOgREhr/B5coEi9pUcixdwkJBGr7+ZudeSeQCF1druTF5AIFycfexgnRbddHtIO94gSjgjf92IzKYZVRuGSqEWLcEQkw7cXDdUyo3BJ1PJqYjgi6m0i5TOh7qdbUq8nUFwi3CD1dZCXfhNPYhORlsaFTLcstjeXoxMx7VG0w+77Ep+IVBnr+b5EKCL13mOPUoRXDiIQgQhEIAIRiEAEIhCBCETcQcTMSkSufkFAZ5999iumKyVBiDikP0TM/SFi7u/kIvgneZ5NuMFDGjM8rTJT26dXAd6hPOVjOzy/dIMHue7wRBsAAAAAAAAAAAAAAAAAAAAAAMA5+A/Dez7cvnkYRAAAAABJRU5ErkJggg=='
